import React from 'react';
import PropTypes from 'prop-types';
import { AButton } from '../atoms/';

export default function MCmsLanguagePicker({
	items,
	active,
	onClick,
}) {
	const handleClick = (item) => {
		onClick(item.uuid);
	};
	const handleKeyUp = (event, item) => {
		if (event.keyCode !== 13) {
			return;
		}
		onClick(item);
	};

	return (
		<article className="m-language-picker--cms">
			{
				items.map(item => (
					<button
						key={item.uuid}
						className={item.uuid === active ? 'active' : ''}
						onClick={() => handleClick(item)}
						onKeyUp={event => handleKeyUp(event, item)}
					>
						{item.tag}
					</button>
				))
			}
		</article>
	);
}
// <Link to={href} href={href}>
MCmsLanguagePicker.propTypes = {
	items: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.cms-language-picker.js